"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStylesFn = exports.defaultModifierStyles = exports.defaultWeekModifiers = exports.defaultDayModifiers = exports.createStyles = exports.Calendar = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var HFlow_1 = require("../HFlow");
var MonthControl_1 = require("./MonthControl");
var MonthView_1 = require("./MonthView");
var util_1 = require("./util");
var YearControl_1 = require("./YearControl");
function Calendar(props) {
    var onlyWeeks = props.onlyWeeks, visibleDate = props.visibleDate, modifiers = props.modifiers, modifierStyles = props.modifierStyles, onVisibleDateChange = props.onVisibleDateChange, onMouseLeave = props.onMouseLeave, isDaySelected = props.isDaySelected, rest = __rest(props, ["onlyWeeks", "visibleDate", "modifiers", "modifierStyles", "onVisibleDateChange", "onMouseLeave", "isDaySelected"]);
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, theme = _a.theme;
    var allModifiers = react_1.useMemo(function () { return (__assign(__assign({}, (onlyWeeks ? exports.defaultWeekModifiers : exports.defaultDayModifiers)), modifiers)); }, [
        modifiers,
        onlyWeeks,
    ]);
    var allModifierStyles = react_1.useMemo(function () { return (__assign(__assign({}, exports.defaultModifierStyles), modifierStyles)); }, [modifierStyles]);
    var createDateStyles = react_1.useMemo(function () { return exports.createStylesFn(allModifiers, allModifierStyles, theme); }, [
        allModifiers,
        allModifierStyles,
        theme,
    ]);
    var handleDayClick = react_1.useCallback(function (day) {
        if (!allModifiers.disabled(day, props)) {
            onVisibleDateChange(day);
            return props.onDayClick && props.onDayClick(day);
        }
    }, [allModifiers, onVisibleDateChange, props]);
    var handleWeekClick = react_1.useCallback(function (week) {
        if (!allModifiers.disabled(week, props)) {
            onVisibleDateChange(week.start);
            return props.onWeekClick && props.onWeekClick(week);
        }
    }, [allModifiers, onVisibleDateChange, props]);
    return (react_1.default.createElement("div", { className: classes.root, onMouseLeave: onMouseLeave },
        react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 0.5, justifyContent: 'space-around', style: classes.controls },
            react_1.default.createElement(MonthControl_1.MonthControl, { visibleDate: visibleDate, onChange: onVisibleDateChange }),
            react_1.default.createElement(YearControl_1.YearControl, { visibleDate: visibleDate, onChange: onVisibleDateChange })),
        react_1.default.createElement(MonthView_1.MonthView, __assign({ visibleDate: visibleDate, createDateStyles: createDateStyles }, rest, { onDayClick: handleDayClick, isDaySelected: isDaySelected, onWeekClick: handleWeekClick, onlyWeeks: onlyWeeks }))));
}
exports.Calendar = Calendar;
exports.createStyles = function () { return ({
    root: {
        width: 288,
    },
    controls: {
        marginBottom: '0.5rem',
        fontWeight: 'bold',
    },
}); };
exports.defaultDayModifiers = {
    today: function (day) { return util_1.isSameDay(new Date(), day); },
    disabled: function () { return false; },
    selected: function () { return false; },
    adjacentMonth: function (day, _a) {
        var visibleDate = _a.visibleDate;
        return visibleDate.getMonth() !== day.getMonth();
    },
};
exports.defaultWeekModifiers = {
    today: function (week) { return util_1.isBelongingAWeek(new Date(), week); },
    disabled: function () { return false; },
    selected: function () { return false; },
    adjacentMonth: function () { return false; },
};
exports.defaultModifierStyles = {
    today: function () { return ({
        fontWeight: 'bold',
    }); },
    disabled: function (theme) { return ({
        color: theme.pallete.text.disabled,
        ':hover': {
            background: 'initial',
            cursor: 'not-allowed',
        },
    }); },
    selected: function (theme) { return ({
        background: theme.pallete.primary.main,
        color: theme.pallete.surface.main,
        fontWeight: 'bold',
        ':hover': {
            background: theme.pallete.primary.main,
            color: theme.pallete.surface.main,
        },
    }); },
    adjacentMonth: function (theme) { return ({
        color: theme.pallete.text.disabled,
    }); },
};
exports.createStylesFn = function (modifiers, styles, theme) { return function (element, props) {
    return Object.keys(modifiers).reduce(function (s, modifier) {
        if (!styles[modifier]) {
            throw new Error("You must provied a modifierStyle for predicate \"" + modifier + "\"");
        }
        return __assign(__assign({}, s), (modifiers[modifier](element, props) ? styles[modifier](theme) : {}));
    }, {});
}; };
//# sourceMappingURL=Calendar.js.map